import { Dispatch, SetStateAction } from "react";
import { PickerValue } from "@mui/x-date-pickers/internals";
import dayjs, { Dayjs } from "dayjs";

export interface ActivityIncidentFormData {
  date: Dayjs | PickerValue;
  time: Dayjs | PickerValue;
  description: string;
}

export interface ActivityIncidentFormErrors {
  date: string | null;
  time: string | null;
  description: string | null;
}

export const defaultActivityIncidentFormErrors: ActivityIncidentFormErrors = {
  date: null,
  time: null,
  description: null,
};

export const validateActivityIncidentField = ({ field, value, stateHandler, formErrors }: {
  field: keyof ActivityIncidentFormData,
  value: any,
  stateHandler: Dispatch<SetStateAction<any>>,
  formErrors: any,
}) => {
  const fieldDisplayName = field[0].toUpperCase() + field.slice(1);
  const validations = {
    date: {
      required: true,
      isPast: true,
    },
    time: {
      required: true,
      isPast: true,
    },
    description: {
      required: true,
      isPast: undefined
    },
  } as const;

  const validation = validations[field];
  if (!validation) return;

  if (validation.required && !value) {
    stateHandler({ ...formErrors, [field]: `${fieldDisplayName} is required` });
    return;
  }

  if (validation?.isPast && value) {
    const now = dayjs();
    if (value.isAfter(now)) {
      stateHandler({
        ...formErrors,
        date: 'Date cannot be in the future',
        time: 'Time cannot be in the future'
      });
      return;
    } else {
      stateHandler({ ...formErrors, date: null, time: null });
      return;
    }
  }

  stateHandler({ ...formErrors, [field]: null });
};

export const parseActivityIncidentFormData = (data: ActivityIncidentFormData) => {
  const { date, time, description } = data;
  return {
    date: date?.format('YYYY-MM-DD'),
    time: time?.format('HH:mm:ss'),
    description,
  };
};